import { createApp } from 'vue'
import RegistrationForm from '@/components/RegistrationForm.vue'
import CabinetLogin from '@/components/Cabinet/CabinetLogin.vue'
import CabinetLeadsList from '@/components/Cabinet/CabinetLeadsList.vue'
import CreditCalculator from '@/components/CreditCalculator/CreditCalculator.vue'
import CreditCalculatorLemonza from '@/components/CreditCalculator/CreditCalculatorLemonza.vue'
import CreditCalculatorZaymovich from '@/components/CreditCalculator/CreditCalculatorZaymovich.vue'
import CreditCalculatorSingleOffer from '@/components/CreditCalculator/CreditCalculatorSingleOffer.vue'
import TableOfContent from '@/components/TableOfContent.vue'
import Reviews from '@/components/Reviews/Reviews.vue'
import AppMain from '@/components/AppMain.vue'
import {data} from "@/assets/js/Functions";


import store from '@/store/EventBus'

import { VueReCaptcha } from 'vue-recaptcha-v3'
const siteKey = '6LeQyQkpAAAAABBVAtsZvGF_GBaEtGGfnqRATdFH'


// Проверяем существование элемента с ID "app"
var appElement = document.getElementById("app");
if (!appElement) {
    appElement = document.createElement("div");
    appElement.id = "app";
    document.body.appendChild(appElement);
}

const App = createApp(AppMain)
App.mount('#app');

const RegistrationFormApp = createApp(RegistrationForm)
RegistrationFormApp.mount('#RegistrationForm')

const ReviewsApp = createApp(Reviews).use(VueReCaptcha, { siteKey })
ReviewsApp.mount('#Reviews')

const CabinetLoginApp = createApp(CabinetLogin).use(VueReCaptcha, { siteKey })
CabinetLoginApp.mount('#CabinetLogin')

const CabinetLeadsListApp = createApp(CabinetLeadsList).use(VueReCaptcha, { siteKey })
CabinetLeadsListApp.use(store)
CabinetLeadsListApp.mount('#CabinetLeadsList')

const TableOfContentApp = createApp(
    TableOfContent,
    {
        title: data('#TableOfContent', 'title'),
        contentSelector: data('#TableOfContent', 'content'),
    })
TableOfContentApp.mount('#TableOfContent');

const calculators = document.querySelectorAll('.CreditCalculator, .CreditCalculatorLemonza, .CreditCalculatorZaimoo, .CreditCalculatorZaymovich, .CreditCalculatorSingleOffer')
calculators.forEach((element) => {
    let elementApp;

    if (element.classList.contains('CreditCalculator')) {
        elementApp = CreditCalculator;
    } else if (element.classList.contains('CreditCalculatorLemonza') || element.classList.contains('CreditCalculatorZaimoo')) {
        elementApp = CreditCalculatorLemonza;
    } else if (element.classList.contains('CreditCalculatorZaymovich')) {
        elementApp = CreditCalculatorZaymovich;
    } else if (element.classList.contains('CreditCalculatorSingleOffer')) {
        elementApp = CreditCalculatorSingleOffer;
    }

    const calculator = createApp(
        elementApp,
        {
            element: element
        })
    calculator.mount(element)
})
